<template>
  <div
    class="inline-flex items-center gap-x-[2px] rounded-[6px] border px-[7px] py-[2px] text-[11px] font-medium leading-[18px]"
    :class="[
      {
        'border-gpx_red-300 bg-gpx_red-300 text-gpx_red-100':
          variant === BADGE_VARIANT.error,
        'border-gpx_yellow-300 bg-gpx_yellow-300 text-gpx_yellow-100':
          variant === BADGE_VARIANT.warning,
        'border-gpx_green-300 bg-gpx_green-300 text-gpx_green-100':
          variant === BADGE_VARIANT.success,
        'border-gpx_gray-800 bg-white text-gpx_black-500':
          variant === BADGE_VARIANT.default,
        'border-gpx_gray-800 bg-gpx_gray-800 text-gpx_black-500':
          variant === BADGE_VARIANT.unset,
      },
    ]"
  >
    <slot name="icon" />
    <slot />
  </div>
</template>

<script>
import { BADGE_VARIANT } from './utils';

export default {
  props: {
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      BADGE_VARIANT: BADGE_VARIANT,
    };
  },
};
</script>
